import SubPageLayout from '../helpers/SubPageLayout';


const ContractorsView = () => {
  

  return (
    <SubPageLayout title="Contractors">
      
    </SubPageLayout>
  );
};

export default ContractorsView;